import { tw } from 'twind';
import { IMaskInput } from 'react-imask';

const dangerColor = '#EB5757';

interface NationalPhoneNumberInputProps {
  value: string;
  onChange: (num: string) => void;
  className?: string;
  mask: any;
  required?: boolean;
  autoFocus?: boolean;
  hasError?: boolean;
}

export default function NationalPhoneNumberInput({
  value = '',
  onChange,
  className,
  mask = '(000)-000-0000',
  required = false,
  autoFocus = true,
  hasError = false,
}: NationalPhoneNumberInputProps) {
  return (
    <IMaskInput
      required={required}
      value={value}
      autoFocus={autoFocus}
      mask={mask}
      unmask={true}
      autoComplete="off"
      type="tel"
      name="telephone"
      className={tw`${className} ${hasError && `text-[${dangerColor}]`}`}
      onAccept={(value, mask) => {
        onChange(String(value));
      }}
    />
  );
}
